"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _pluck = _interopRequireDefault(require("transmute/pluck"));

var _some = _interopRequireDefault(require("transmute/some"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _EmailMediator = require("customer-data-email/schema/email/EmailMediator");

var _EmailContentMediator = require("customer-data-communicator/schema/interactions/email/EmailContentMediator");

var _CommunicatorStore = _interopRequireDefault(require("customer-data-communicator/data/communicator/stores/CommunicatorStore"));

// This dependency assumes the initial content in the CommuncatorStore is EmailContent. Recipients are
// contact vids that are resolved to ContactRecords in toEmailIntearctionRecord.
var pluckId = (0, _pluck.default)('id');

var notResolved = function notResolved(c) {
  return !(0, _LoadingStatus.isResolved)(c);
};

var toContacts = function toContacts(emailContent) {
  var to = emailContent.to,
      ccs = emailContent.ccs,
      bccs = emailContent.bccs;
  var contacts = to ? _immutable.Seq.of(to) : (0, _immutable.Seq)();
  return _ContactsStore.default.get(pluckId(contacts.concat(ccs).concat(bccs).map(_EmailMediator.toContactInfo)));
};

var notFullyResolved = (0, _pipe.default)(toContacts, (0, _some.default)(notResolved));
var dependencies = {
  initialInteraction: {
    stores: [_ContactsStore.default, _CommunicatorStore.default],
    deref: function deref(_ref) {
      var interaction = _ref.interaction;

      var initialContent = _CommunicatorStore.default.get('initialContent');

      if (!initialContent) {
        return _LoadingStatus.EMPTY;
      }

      var emailContent = initialContent.get(_InteractionTypes.EMAIL);

      if (!emailContent) {
        return _LoadingStatus.EMPTY;
      }

      if (notFullyResolved(emailContent)) {
        return _LoadingStatus.LOADING;
      }

      return (0, _EmailContentMediator.toEmailInteractionRecord)(interaction, emailContent, _ContactsStore.default);
    }
  }
};
var _default = dependencies;
exports.default = _default;
module.exports = exports.default;